// This page is "v2" of the BallCap display, and goes with the "BallcapSessionContainer.jsx" page. The other files
// in this folder are the "v1" files.
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LoadingSpinner, BallCapSessionDisplay as BallcapSessionComponent } from 'yankees-react-utils';
import usePlayerSelector from '../../utils/usePlayerSelector';
import { useVideoPlayerFns } from '../../components/VideoPlayer';

const StyledLoadingSpinner = styled.div`
    display: flex;
    justify-content: center;
`;

const BallcapSession = ({ isLoading, isBullpen, isTrackmanSyntheticSession, sessionData, showAllCheckbox }) => {
    const player = usePlayerSelector();
    const { grabFrame, download, reportBadVideo } = useVideoPlayerFns({}, player);

    // Only show the spinner on the very first load (no data yet). On subsequent
    // session changes we keep the previous session's content (and its embedded
    // BallR iframe) mounted while the next session fetches, so the iframe doesn't
    // tear down and reload.
    if (isLoading && sessionData == null) {
        return (<StyledLoadingSpinner><LoadingSpinner /></StyledLoadingSpinner>);
    }

    if (sessionData == null) {
        return null;
    }

    return (
        <BallcapSessionComponent
            isBullpen={isBullpen}
            isTrackmanSyntheticSession={isTrackmanSyntheticSession}
            data={sessionData}
            showAllCheckbox={showAllCheckbox}
            ballrMiniFrameSource="/ballr-mini/index.html"
            height="85vh" // we're using 85vh here because it fits nicely on the portal average side without the scrollbars
            download={download}
            grabFrame={grabFrame}
            reportBadVideo={reportBadVideo}
            isPlayerPortal
        />
    );
};

BallcapSession.propTypes = {
    sessionData: PropTypes.shape({}),
    isBullpen: PropTypes.bool.isRequired,
    isTrackmanSyntheticSession: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    showAllCheckbox: PropTypes.bool.isRequired,
};

BallcapSession.defaultProps = {
    sessionData: null,
};

export default BallcapSession;
